
import React from 'react'
import { FilterSelectPc } from '../FilterSelect/FilterSelectPc'
import { useSearchConditionPc } from '../hooks/useSearchCondition';
import { SelectProps } from 'antd';

export interface FilterAffiliateCollaboratorPcProps extends SelectProps {

}  


export const FilterAffiliateCollaboratorPc = (props: FilterAffiliateCollaboratorPcProps) => {
  const { searchCondition, loading, } = useSearchConditionPc({ affiliate_situation: ["company"] },{manual:false});
  const { placeholder = '运营公司',  ...reset } = props;
  let options = (searchCondition.affiliate_situation?.company ||[])
  
  return <FilterSelectPc
    defaultFilterOption
    options={options}
    // getInitData={getInitData}
    loading={loading}
    placeholder={placeholder}
    {...reset}
    allowClear={false}
  />
}